export enum BcmSupportedCurrencyCodes {
    EUR = 'EUR',
    CHF = 'CHF'
}

export enum BcmSupportedCurrencySymbols {
    EUR = '€',
    CHF = 'CHF'
}
